import { buildTestId } from '~/utils/buildTestId';

export const PATIENTS_TABS = {
  recent: 0,
  all: 1,
} as const;

const PATIENTS_TABS_LABEL: Record<
  (typeof PATIENTS_TABS)[keyof typeof PATIENTS_TABS],
  string
> = {
  [PATIENTS_TABS.all]: 'All Patients',
  [PATIENTS_TABS.recent]: 'Recent Patients',
} as const;

type PatientsTabsKey = keyof typeof PATIENTS_TABS;
export type PatientsTabsValue =
  (typeof PATIENTS_TABS)[keyof typeof PATIENTS_TABS];

export const PatientsTabsConfig = (testID: string) =>
  (Object.keys(PATIENTS_TABS) as PatientsTabsKey[]).map((key) => {
    const label = PATIENTS_TABS_LABEL[PATIENTS_TABS[key]];

    return {
      label,
      'aria-label': label,
      testID: buildTestId({ testID, suffix: ['tab', label] }),
    };
  });
